<template>
  <div class="panel card">

    <fragment v-if="title">
      <div class="card-title">
        <h2>{{ title }}</h2>

        <div v-if="actions" class="container-actions">
          <button
            v-for="action in actions.getActions()"
            :key="action.id"
            @click.stop="action.action"
          >
            <component
              :is="action.icon"
              :data="action.icon"
              :size="22"
            />
          </button>
        </div>
      </div>
      <div class="divider"></div>
      <div class="card-body">
        <slot />
      </div>
    </fragment>

  </div>
</template>

<script>

import CardActions from './CardActions';

export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      required: true,
    },
    actions: {
      type: CardActions,
    },
  },
};
</script>

<style scooped>
  button span {
    font-size: 18px;
  }
</style>
